type QuestionType = "point-distribution" | "multiple-choice" | "ranking";

interface SurveyQuestion {
  id: number;
  question: string;
  options: { id: number; text: string }[];
  type: QuestionType;
}

// Turkish Questions
const surveyQuestionsTR: SurveyQuestion[] = [
  {
    id: 1,
    question: "Organizasyon yapınızı nasıl tanımlarsınız?",
    options: [
      {
        id: 101,
        text: "Ekip içi paylaşım yüksektir. Çalışanlar birbirini destekler. Biz bir aileyiz.",
      },
      {
        id: 102,
        text: "Çalışanlar sorumluluk ve risk alır. Dinamik, girişimci ruhluyuz.",
      },
      {
        id: 103,
        text: "Rekabet yüksektir ve başarıya önem veririz. Sonuç odaklıyız ve işin hızlı tamamlanmasını önemseriz.",
      },
      {
        id: 104,
        text: "Prosedürler ve sorumluluklar net olarak belirlenmiştir.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 2,
    question: "Organizasyonunuzu nasıl tanımlarsınız?",
    options: [
      {
        id: 201,
        text: "Ekip çalışması önemlidir, fikir birliğinin sağlanması için tüm üyelerin görüşleri dinlenir.",
      },
      {
        id: 202,
        text: "Çalışanların fikirleri ve talepleri değerlidir. Yenilik, özgürlük ve özgünlüğe önem verilir.",
      },
      {
        id: 203,
        text: "Hedeflere ulaşmak ve başarılı olmak önemlidir, bu yüzden organizasyon içi rekabet yüksektir.",
      },
      {
        id: 204,
        text: "İstikrar önemlidir, planlı düzenli ve güvenilir bir organizasyondur.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 3,
    question: "Organizasyonunuzda ekipleri bir arada tutan şey nedir?",
    options: [
      { id: 301, text: "Sadakat, karşılıklı güven ve bağlılıktır." },
      {
        id: 302,
        text: "Yeniliğe açık olmak, sürekli gelişmek ve teknolojiyi kullanmaya odaklanmaktır.",
      },
      { id: 303, text: "Başarıya ve hedefe ulaşma arzusudur." },
      { id: 304, text: "Kurallar ve düzendir." },
    ],
    type: "point-distribution",
  },
  {
    id: 4,
    question: "Organizasyonunuz neyi önemser?",
    options: [
      {
        id: 401,
        text: "Çalışanların gelişimi, güven ortamının sağlanması, samimi ve katılımcı olmak.",
      },
      {
        id: 402,
        text: "Yeni kaynaklar ve meydan okumalar yaratmak. Yeni fırsatlar yakalayabilmeleri için çalışanları yeni şeyler denemeye teşvik etmek.",
      },
      { id: 403, text: "Rekabet, başarı, hedeflere ulaşmak ve kazanmak." },
      {
        id: 404,
        text: "Organizasyonun kalıcılığı, sürdürülebilirlik, verimlilik ve sorunsuz operasyon yönetmek.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 5,
    question: "Organizasyonunuzun başarı kriteri nedir?",
    options: [
      {
        id: 501,
        text: "Çalışanların geliştirilmesi, takım çalışması, çalışan bağlılığı ve insan odaklı olmak.",
      },
      {
        id: 502,
        text: "En eşsiz, en yenilikçi ve mükemmel ürünlere sahip olmak.",
      },
      { id: 503, text: "Rekabetçi ortamlarda bile pazar lideri olmak." },
      {
        id: 504,
        text: "Verimlilik, güvenilir teslimat, sorunsuz planlama ve düşük maliyetli üretim yapabilmek.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 6,
    question: "Organizasyonunuzun liderlik bakış açısı nasıldır?",
    options: [
      {
        id: 601,
        text: "Liderler ekibine mentörlük eder, destekler ve gelişmesini sağlar.",
      },
      {
        id: 602,
        text: "Liderler ekiplerini girişimciliğe, yeniliğe ve risk almaya yönlendirir.",
      },
      {
        id: 603,
        text: "Liderler ekiplerinin sonuç odaklı ve hızlı olmasını bekler.",
      },
      {
        id: 604,
        text: "Liderler ekiplerini iyi organize eder, verimli, sorunsuz çalışmalarını sağlar.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 7,
    question: "Organizasyonunuzun çalışma ortamını tanımlayınız.",
    options: [
      {
        id: 701,
        text: "Yalnız çalışmak bir tercih olabilir. Bu sayede çalışanlar daha verimli ve odaklı çalışabilirler.",
      },
      {
        id: 702,
        text: "Ekiple birlikte iş bölümü yaparak problemlere daha hızlı ve farklı çözümler üretebilmeyi önemseriz.",
      },
      {
        id: 703,
        text: "Ekip üyeleri iş dışında da birlikte eğlenceli vakit geçirebilirler.",
      },
      {
        id: 704,
        text: "Ekip üyeleri birbirlerine geri bildirimler vererek gelişmelerini sağlarlar.",
      },
      {
        id: 705,
        text: "Çalışanın motivasyonunu düşürdüğü için geribildirim verilmez.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 8,
    question:
      "Organizasyonunuzda çalışanlarınıza sunduğunuz kariyer imkanları ve ödüllendirmeler nelerdir?",
    options: [
      { id: 801, text: "Liderlik eğitimleri." },
      { id: 802, text: "Başarılı çalışanlar için ek maddi ödüllendirmeler." },
      {
        id: 803,
        text: "Bir üst pozisyon için hazır olan çalışanların şartsız terfi edilmesi.",
      },
      {
        id: 804,
        text: "Başarılı çalışanların organizasyona duyurulması ve manevi ödüllendirmeler.",
      },
    ],
    type: "multiple-choice",
  },
  {
    id: 9,
    question:
      "Aşağıdaki seçenekleri organizasyonunuz için en önemli olandan en az önemli olana doğru sıralayınız.",
    options: [
      { id: 901, text: "Şirket kültürü" },
      { id: 902, text: "Takım çalışması" },
      { id: 903, text: "Çalışana sunulan maaş ve yan haklar" },
      { id: 904, text: "Kişisel gelişim" },
      { id: 905, text: "Kariyer gelişimi ve terfi imkanı" },
      { id: 906, text: "İş yaşam dengesi" },
      {
        id: 907,
        text: "Şirketin fiziksel koşulları (Ofis ortamı, ekipman desteği vb.)",
      },
      {
        id: 908,
        text: "Çalışma şekli ve saatleri (Remote çalışma ve esnek çalışma saatleri imkanı varsa önem sırasında yukarıda olmalı)",
      },
      {
        id: 909,
        text: "İş tatmini (Yeni projede çalışma imkanı ve yeni teknolojileri kullanma imkanı varsa önem sırasında yukarıda olmalı)",
      },
    ],
    type: "ranking",
  },
];

// English Questions
const surveyQuestionsEN: SurveyQuestion[] = [
  {
    id: 1,
    question: "How would you describe your organizational structure?",
    options: [
      {
        id: 101,
        text: "High internal collaboration. Employees support each other. We are a family.",
      },
      {
        id: 102,
        text: "Employees take responsibility and risks. We are dynamic and entrepreneurial.",
      },
      {
        id: 103,
        text: "High competition and focus on success. We are results-oriented and value quick completion.",
      },
      {
        id: 104,
        text: "Procedures and responsibilities are clearly defined.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 2,
    question: "How would you define your organization?",
    options: [
      {
        id: 201,
        text: "Teamwork is important, all members' opinions are heard to reach consensus.",
      },
      {
        id: 202,
        text: "Employees' ideas and requests are valued. Innovation, freedom and authenticity matter.",
      },
      {
        id: 203,
        text: "Reaching goals and being successful is important, so internal competition is high.",
      },
      {
        id: 204,
        text: "Stability is important, we are a planned, orderly and reliable organization.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 3,
    question: "What keeps your teams together?",
    options: [
      { id: 301, text: "Loyalty, mutual trust and commitment." },
      {
        id: 302,
        text: "Being open to innovation, continuous improvement and focus on technology.",
      },
      { id: 303, text: "Desire for success and achieving goals." },
      { id: 304, text: "Rules and order." },
    ],
    type: "point-distribution",
  },
  {
    id: 4,
    question: "What does your organization value most?",
    options: [
      {
        id: 401,
        text: "Employee development, creating a safe environment, being sincere and participative.",
      },
      {
        id: 402,
        text: "Creating new resources and challenges. Encouraging employees to try new things to seize new opportunities.",
      },
      { id: 403, text: "Competition, success, reaching goals and winning." },
      {
        id: 404,
        text: "Organizational continuity, sustainability, efficiency and smooth operations.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 5,
    question: "What is your organization's success criterion?",
    options: [
      {
        id: 501,
        text: "Developing employees, teamwork, employee engagement and being human-oriented.",
      },
      {
        id: 502,
        text: "Having the most unique, innovative and excellent products.",
      },
      { id: 503, text: "Being market leader even in competitive environments." },
      {
        id: 504,
        text: "Efficiency, reliable delivery, smooth planning and low-cost production.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 6,
    question: "What is your organization's leadership perspective?",
    options: [
      {
        id: 601,
        text: "Leaders mentor, support and foster their team's development.",
      },
      {
        id: 602,
        text: "Leaders guide their teams toward entrepreneurship, innovation and risk-taking.",
      },
      {
        id: 603,
        text: "Leaders expect their teams to be results-oriented and fast.",
      },
      {
        id: 604,
        text: "Leaders organize their teams well, ensuring efficient and smooth work.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 7,
    question: "Describe your organization's work environment.",
    options: [
      {
        id: 701,
        text: "Working alone can be a preference. This allows employees to be more efficient and focused.",
      },
      {
        id: 702,
        text: "We value dividing work among the team to solve problems faster and with different perspectives.",
      },
      {
        id: 703,
        text: "Team members can spend fun time together outside of work.",
      },
      {
        id: 704,
        text: "Team members provide feedback to each other to support development.",
      },
      {
        id: 705,
        text: "Feedback is not given as it demotivates the employee.",
      },
    ],
    type: "point-distribution",
  },
  {
    id: 8,
    question:
      "What career opportunities and rewards do you offer your employees?",
    options: [
      { id: 801, text: "Leadership trainings." },
      { id: 802, text: "Additional financial rewards for successful employees." },
      {
        id: 803,
        text: "Unconditional promotion of employees ready for higher positions.",
      },
      {
        id: 804,
        text: "Announcing successful employees to the organization and non-financial rewards.",
      },
    ],
    type: "multiple-choice",
  },
  {
    id: 9,
    question:
      "Rank the following options from most important to least important for your organization.",
    options: [
      { id: 901, text: "Company culture" },
      { id: 902, text: "Teamwork" },
      { id: 903, text: "Salary and benefits offered to employees" },
      { id: 904, text: "Personal development" },
      { id: 905, text: "Career development and promotion opportunities" },
      { id: 906, text: "Work-life balance" },
      {
        id: 907,
        text: "Physical conditions of the company (Office environment, equipment support, etc.)",
      },
      {
        id: 908,
        text: "Work style and hours (If remote work and flexible hours are available, should be higher in priority)",
      },
      {
        id: 909,
        text: "Job satisfaction (If opportunity to work on new projects and use new technologies is available, should be higher in priority)",
      },
    ],
    type: "ranking",
  },
];

// Get questions by language
export const getSurveyQuestions = (language: string = "tr"): SurveyQuestion[] => {
  switch (language) {
    case "en":
      return surveyQuestionsEN;
    case "tr":
    default:
      return surveyQuestionsTR;
  }
};

// Backward compatibility - default to Turkish
export const surveyQuestions = surveyQuestionsTR;
